import { router } from 'expo-router';

export type DirectDepositSetupEntryPoint =
  | 'move-money'
  | 'direct-deposit-benefits'
  | 'onboarding-funding'
  | 'onboarding-funding-v2'
  | 'onboarding-direct-deposit-benefits';

interface NavigateToDirectDepositSetupOptions {
  entry: DirectDepositSetupEntryPoint;
  flowId?: string;
  sourceName: string;
  abCohort: string;
  isCoinLoader?: boolean;
  standAloneEntry?: boolean;
}

const onboardingEntries: DirectDepositSetupEntryPoint[] = [
  'onboarding-funding',
  'onboarding-funding-v2',
  'onboarding-direct-deposit-benefits',
];

export const isOnboardingDirectDepositSetupEntry = (
  entry: DirectDepositSetupEntryPoint,
) => onboardingEntries.includes(entry);

export const getDirectDepositSetupPathname = (
  entry: DirectDepositSetupEntryPoint,
) =>
  isOnboardingDirectDepositSetupEntry(entry)
    ? '/onboarding/direct-deposit-setup'
    : '/direct-deposit-setup';

export const navigateToDirectDepositSetup = ({
  entry,
  flowId,
  sourceName,
  abCohort,
  isCoinLoader,
  standAloneEntry,
}: NavigateToDirectDepositSetupOptions) => {
  const pathname = getDirectDepositSetupPathname(entry);

  const navigationPayload = {
    pathname,
    params: {
      entry,
      ...(flowId ? { flowId } : {}),
      sourceName,
      abCohort,
      ...(standAloneEntry ? { standAloneEntry: String(standAloneEntry) } : {}),
      ...(typeof isCoinLoader === 'boolean'
        ? { isCoinLoader: String(isCoinLoader) }
        : {}),
    },
  } as const;

  router.push(navigationPayload);
};
